export default __webpack_public_path__ + "static/transcribe-22246591b01b7f4f1a8d7b3f256706b2.svg";